import { Box } from "@mantine/core";
import type { ReactNode } from "react";
import classes from "./StatusLine.module.css";

export interface StatusLineProps {
  children: ReactNode;
}

/** Ногоон цэгтэй богино мэдэгдэл (Код илгээлээ г.м.). */
export function StatusLine({ children }: StatusLineProps) {
  return (
    <Box role="status" className={classes.root}>
      <Box component="span" className={classes.dot} aria-hidden="true" />
      {children}
    </Box>
  );
}
